import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const LinkedInIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21ZM15.8285 18.4996H18.4996V13.0124C18.4996 10.6907 17.1835 9.56816 15.3452 9.56816C13.5061 9.56816 12.7321 11.0003 12.7321 11.0003V9.83294H10.1579V18.4996H12.7321V13.9501C12.7321 12.7311 13.2933 12.0057 14.3673 12.0057C15.3546 12.0057 15.8285 12.7028 15.8285 13.9501V18.4996ZM5.49961 7.09886C5.49961 7.98202 6.21012 8.69811 7.08695 8.69811C7.96377 8.69811 8.67386 7.98202 8.67386 7.09886C8.67386 6.2157 7.96377 5.49961 7.08695 5.49961C6.21012 5.49961 5.49961 6.2157 5.49961 7.09886ZM8.44196 18.4996H5.75775V9.83294H8.44196V18.4996Z"
      />
    </SvgIcon>
  );
});
